import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCAekfS2OpckVUubUX3NFmg3HRTPZDq34E",
  authDomain: "wiffle-ball-league.firebaseapp.com",
  projectId: "wiffle-ball-league",
  storageBucket: "wiffle-ball-league.firebasestorage.app",
  messagingSenderId: "1076620123140",
  appId: "1:1076620123140:web:f511b413a4223037b8a951"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);